import { Spinner } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import { isIOS } from 'react-device-detect';
import Stopper from '../../../components/Stopper';
import { getEnv, managementEnvironment } from '../../../utils/dataTransformation/environments';

const LoginApp: React.FC = () => {
    const loginDisabled = managementEnvironment().VITE_STOPPER_LOGIN_DISABLED;

    useEffect(() => {
        if (!loginDisabled) {
            const url_params = window.location.search;
            window.location.href = `${getEnv('VITE_LOGIN_URL_APP')}${url_params}`;
        }
    }, [loginDisabled]);

    if (loginDisabled) return <Stopper />;

    return (
        <>
            {isIOS && (
                <div className='c-spinner'>
                    <Spinner size={24} />
                    <span className='c-spinner-overlay'></span>
                </div>
            )}
        </>
    );
};

export default LoginApp;
